<template>
  <div>

    <!--style="position:fixed;z-index:7;"-->

    <v-container class="mt-0 pt-0 mb-0 pb-0 maxwidth" style="position:fixed;z-index:7;">

      <v-row v-if="title=='addStoryInJourney'" align="center" class="mt-0 pt-0 mb-0 pb-0 secondaryVariant">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goToPage('home')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t(title)}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='createNewJourneyContent'" align="center" class="mt-0 pt-0 mb-0 pb-0 secondaryVariant">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goToPage('home')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t(title)}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='home'||title=='map'" align="center" class="mt-0 pt-0 mb-0 pb-0">
        <v-col class="mt-0 pt-0 mb-0 pb-0 pr-0 mr-0" cols=8>
          <!--h2 class="headertitle text-left">{{title}}</h2-->
          <!--v-img class="logoHeader" :src="require('@/assets/MEMEX-logo.svg')"></v-img-->
          <searchBarFilterJourney  v-if="isToggleJourneyView"/>
          <searchBarFilter v-else />
        </v-col>
        <v-col align="center" class="mt-0 pt-0 mb-0 pb-0 mx-0 px-0 " cols="1">
          <modalFilter v-if="!isToggleJourneyView" />
        </v-col>
        <v-col align="center" class="mt-0 pt-0 mb-0 pb-0 mx-0 px-0 " cols="1">
          <toggleJourneyView />
        </v-col>
        <v-col align="center" class="mt-0 pt-0 mb-0 pb-0 text-right mx-0 px-0 " cols="1">
          <deepLinkButton v-if="menu" />
        </v-col>
        <v-col align="center" class="mt-0 pt-0 mb-0 pb-0 text-right mx-0 px-0 " cols="1">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='carouselForSingleStoryView'&&isARapp!='true'" align="center" class="mt-0 pt-0 mb-0 pb-0">
        <v-col class="mb-0 pb-0 px-0 text-left" cols="1">
          <v-btn icon text @click="goBack()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t('backToListView')}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='singleStoryKGView'" align="center" class="mt-0 pt-0 mb-0 pb-0 secondaryVariant">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goBack()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{getTitle}}<br />
          {{getPosition}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='singleStoryMapView'" align="center" class="mt-0 pt-0 mb-0 pb-0">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goBack()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{getTitle}}<br />
          {{getPosition}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>
      <v-row v-if="title=='singleJourneyView'&&isARapp!='true'" align="center"
        class="primaryVariant mt-0 pt-0 mb-0 pb-0">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goToPage('home')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t(title)}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>

      <v-row v-if="title=='createNewStoryContent'" align="center" class="mt-0 pt-0 mb-0 pb-0 secondaryVariant">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="saveBeforeExit()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t(title)}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>
      <v-row v-if="title=='createNewStoryContent'" align="center" class="mt-0 pt-0 px-8 pb-4 secondaryVariant" jusialign="center">
        <v-col cols="2" align="left" class="">
          <v-img v-if="!isToggleKG" @click="toggleKG()" class="imageKGiconSize"
            :src="require('@/assets/KGtoggleoff.png')"></v-img>
          <v-img v-else @click="toggleKG()" class="imageKGiconSize" :src="require('@/assets/KGtoggleon.png')"></v-img>
        </v-col>
        <v-col cols="8" align="left" class="px-0 mx-0">
          {{$t('contentSuggestion')}}
        </v-col>
        <v-col cols="2" align="center" class="">
                <v-icon v-if="isTooltipConnectedness" contain
      @click="toggleinformation()"  color=primaryVariant
      >mdi-information</v-icon>
            <v-icon v-else contain color=primary
      @click="toggleinformation()" 
      >mdi-information</v-icon>
      <div v-if="isTooltipConnectedness" style="border-radius:10px;padding:5px;width:200px;position:absolute;top:6rem;right:2rem;color:black;background-image:linear-gradient(to right, #E5FFFF , #81B9BF);"> {{$t("tooltipOpenContentSuggestion")}}</div>

        </v-col>
        <v-col v-show="isToggleKG==true" cols="6" align="center" class="mt-0 pt-0 mb-0 pb-0">
          <v-btn @click="toggleOnlyImage()" v-if="!isOnlyImageFromKG"  class="btnactive" color="primaryVariant">
            <v-icon>mdi-text-box-outline</v-icon>{{$t('searchSuggestionText')}}
          </v-btn>
          <v-btn @click="toggleOnlyImage()" v-else text class="btnnoactive"  color="primaryVariant">
            <v-icon>mdi-text-box-outline</v-icon>{{$t('searchSuggestionText')}}
          </v-btn>
        </v-col>
        <v-col v-show="isToggleKG==true" cols="6" align="center" class="mt-0 pt-0 mb-0 pb-0">
          <v-btn @click="toggleOnlyImage()" v-if="isOnlyImageFromKG" class="btnactive" color="primaryVariant">
            <v-icon>mdi-image-multiple-outline</v-icon> {{$t('searchSuggestionImages')}}
          </v-btn>
          <v-btn @click="toggleOnlyImage()" v-else text class="btnnoactive"  color="primaryVariant">
            <v-icon>mdi-image-multiple-outline</v-icon> {{$t('searchSuggestionImages')}}
          </v-btn>
        </v-col>
        <v-col v-show="isToggleKG==true" cols="10" align="right" class="mt-0 pt-4 mb-0 pb-0 pr-0 mr-0">
          <v-text-field v-on:keyup.enter="setIsSuggestionLoading(true)" :loading="isSearchKGLoading" clerables rounded v-model="searchKGKeyword" :label="$t('search')"
            single-line clearable @clear:append="clearSearchKGKeyword()" prepend-inner-icon="mdi-magnify" dense>
          </v-text-field>
        </v-col>
        <v-col v-show="isToggleKG==true" cols="1" align="left" class="mt-0 pt-4 mb-0 pb-0">
          <v-btn @click="setIsSuggestionLoading(true)" class="mx-0" fab dark small color="primary">
            {{$t('OK')}}</v-btn>
        </v-col>

      </v-row>

      <v-row v-if="title=='createNewStoryPublish'" align="center" class="mt-0 pt-0 mb-0 pb-0 secondaryVariant">
        <v-col class="mb-0 pb-0 px-0 text-center" cols="1">
          <v-btn icon text @click="goToPage('createNewStoryContent')">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0 text-left" cols="9">
          {{$t(title)}}
        </v-col>
        <v-col class="mt-0 pt-0 mb-0 pb-0 text-right" cols="2">
          <mobilenavbar v-if="menu" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import toggleJourneyView from "@/components/toggleJourneyView";
import mobilenavbar from "@/components/mobilenavbar";
import modalFilter from "@/components/modalFilter";
import searchBarFilter from './searchBarFilter.vue';
import searchBarFilterJourney from './searchBarFilterJourney.vue';

import deepLinkButton from "@/components/deepLinkButton"
export default {
  name: 'headerapplic',
  data() {
    return {
      isTooltipConnectedness:false,
      showTooltip:process.env.VUE_APP_SHOWTOOLTIP,
      dialog: false,
      tooltip_search:false,
      tooltip_filter:false,
      tooltip_journey:false,
      tooltip_ARapp:false,
      tooltip_menu:false
    }
  },
    async mounted() {
    },
  props: {
    back: {
      type: String,
      required: false
    },
    close: {
      type: String,
      required: false
    },
    menu: {
      type: Boolean,
      required: true
    }

  },

  computed: {
    isARapp: {
      get: function () {
        return this.$route.query.ARapp;
      }
    },
    isToggleJourneyView: {
      get: function () {
        return this.$store.getters.getIsJourneyOrSingleStory;
      }
    },
    searchKGKeyword: {
      get: function () {
        return this.$store.getters.getSuggestionSearchText
      },
      set(value) {
        this.$store.dispatch('setSuggestionSearchText', value)
      }
    },
    isSearchKGLoading: {
      get: function () {
        return this.$store.getters.getIsSuggestionLoading
      }
    },
    isOnlyImageFromKG: {
      get: function () {
        return this.$store.getters.getIsToggleSuggestionOnlyImageEnable
      }
    },
    isToggleKG: {
      get: function () {
        return this.$store.getters.getIsToggleSuggestionEnable;
      }
    },
    getTitle: {
      get: function () {
        return this.$store.getters.getSingleStoryTitle;
      }
    },
    getPosition: {
      get: function () {
        return this.$store.getters.getSingleStoryPositionOnMap;
      }
    },
    /**/
    //route name == home
    // if tab == 0 all stories
    //if tab == 1 My stories
    title: function () {
      if (this.$route.name == 'home' || this.$route.name == 'map') {
        return this.$route.name;
      } else if (this.$route.name == 'singleStoryView') {
        return this.$route.name;
      } else if (this.$route.name == 'carouselForSingleStoryView') {
        return this.$route.name;
      } else if (this.$route.name == 'singleJourneyView') {
        return this.$route.name;
      } else if (this.$route.name == 'singleStoryKGView') {
        return this.$route.name;
      } else if (this.$route.name == 'singleStoryMapView') {
        return this.$route.name;
      } else if (this.$route.name == 'createNewStoryContent') {
        return this.$route.name;
      } else if (this.$route.name == 'createNewStoryPublish') {
        return this.$route.name;
      } else if (this.$route.name == 'createNewJourneyContent') {
        return this.$route.name;
      } else if (this.$route.name == 'addStoryInJourney') {
        return this.$route.name;
      } else
        return ''
    }
  },
  components: {
    mobilenavbar,
    modalFilter,
    searchBarFilter,
    toggleJourneyView,
    deepLinkButton,
    searchBarFilterJourney
  },
  methods: {
    toggleinformation(){
  this.isTooltipConnectedness=!this.isTooltipConnectedness
},
    setIsSuggestionLoading(value){
              this.$store.dispatch('setIsSuggestionLoading',value)
    },

    setSuggestionSearchBtn(){

this.$store.dispatch("setSuggestionSearchBtn", !this.$store.state.suggestionSearchBtn)
    },
    clearSearchKGKeyword() {
      this.$store.dispatch("setSuggestionSearchText", '')

    },
    toggleOnlyImage() {
      this.$store.dispatch("setIsToggleSuggestionOnlyImageEnable", !this.isOnlyImageFromKG)
    },
    toggleKG() {
      this.$store.dispatch("setIsToggleSuggestionEnable", !this.isToggleKG)
    },
    saveBeforeExit: function () {
      if(this.isToggleKG==true)
        this.$store.dispatch("setIsToggleSuggestionEnable", !this.isToggleKG)
      else{
        this.$store.dispatch("setDialogSaveBeforeExit", true)
      }
    },
    goBack: function () {
      window.history.go(-1);
    },
    goToPage: function (page) {
      //check if router createNewStory/createNewStoryContent
      //ASK IF user want to save the story before leave
      this.$router.push({
        'name': page
      })
    }
  }
}
</script>
<style>
.btnactive{
border-radius: 20px;
width: 100%;
color: #38737A!important;

}
.btnnoactive{
border-radius: 20px;
width:  100%;
color:#38737A;
border:2px solid #38737A;
}
.theme--light.v-input{
background-color: white;
}
.v-text-field.v-input--dense {
  padding-top: inherit;
}

.imageKGiconSize{
  width: 2.5rem;
}
.headertitle{
font-weight: 400;
}
.v-toolbar__content{
  padding: 0px;
}
.mdi.mdi-arrow-left,.mdi.mdi-close,.mdi.mdi-arrow-right{
  font-size:1.5rem;
  }
.v-btn.submitbtn{
  width: 100%;
  height: 4rem;
}
.mdi.mdi-arrow-left{
    position: relative;
    right: 2px;
}
.pageTitle{
    font-size: 1.5rem;
    font-weight: bold;
}
</style>